import { useEffect } from 'react'

import { GetPrivacyPolicyResp } from '@marketplace-web/user-agreements/privacy-center-data'
import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

type Props = {
  data: GetPrivacyPolicyResp | undefined
  isExpanded: boolean
}

const useActiveTocLink = ({ data, isExpanded }: Props) => {
  const breakpoints = useBreakpoint()

  useEffect(() => {
    let observer: IntersectionObserver | undefined

    if (data && breakpoints.desktops) {
      const observableHeadings = document.querySelectorAll('.policy__content section[id]')
      const contentTableLinks = document.querySelectorAll('.policy__contents-table a')

      if (!observableHeadings.length || !contentTableLinks.length) return

      const options = {
        root: null,
        rootMargin: '-20% 0px 0% 0px',
        threshold: 0.1,
      }

      const observerCallback: IntersectionObserverCallback = (
        observedHeadings: Array<IntersectionObserverEntry>,
      ) => {
        observedHeadings.forEach(heading => {
          const { id } = heading.target as HTMLElement
          const currentObservedTocLink = document.querySelector(
            `.policy__contents-table [href="#${id}"]`,
          )

          if (heading.isIntersecting) {
            contentTableLinks.forEach(link =>
              link.classList.remove('policy__contents-table--active-item'),
            )
            currentObservedTocLink?.classList.add('policy__contents-table--active-item')
          }
        })
      }

      observer = new IntersectionObserver(observerCallback, options)

      observableHeadings.forEach(heading => {
        observer!.observe(heading)
      })
    } else {
      observer?.disconnect()
    }
  }, [data, breakpoints, isExpanded])
}

export default useActiveTocLink
